export default class SwVisibleAfter extends ContaoWebpack.Plugin {
	init () {
        this.options = {...{
            offsetTop: 0,
        }, ...this.options};

        if (this.options.offsetTop > 0) {
            this.setupVisibility();
            document.addEventListener("scroll", () => {
                this.setupVisibility()
            });
        } else {
            this.el.classList.add('sw-visible-after-active');
        }
	}

    setupVisibility() {
        if (window.scrollY >= this.options.offsetTop) {
            if (!this.el.classList.contains('sw-visible-after-active')) {
                this.el.classList.add('sw-visible-after-active');
            }
        } else {
            if (this.el.classList.contains('sw-visible-after-active')) {
                this.el.classList.remove('sw-visible-after-active');
            }
        }
    }
}
